import {
  request,
} from '@/api/_service.js'

/**
 * @description 删除实例
 * @param string uri 登录携带的信息
 */
export function DELETE_ENTITY(uri) {
  // 接口请求
  return request({
    url: uri,
    method: 'delete'
  })
}

/**
 * @description 删除实例
 * @param string uri 登录携带的信息
 */
export function PUT_ENTITY({
  uri,
  data
}) {
  // 接口请求
  return request({
    url: uri,
    method: 'put',
    data
  })
}

/**
 * @description 获取所有分析模型
 */
export function ALL_MODULES() {
  // 接口请求
  return request({
    url: '/global/modules',
    method: 'get'
  })
}

/**
 * @description 获取所有持续事件
 */
export function ALL_PERSISTENT_EVENTS() {
  // 接口请求
  return request({
    url: '/global/persistentEvents',
    method: 'get'
  })
}

/**
 * @description 获取所有瞬时事件
 */
export function ALL_TIMELY_EVENTS() {
  // 接口请求
  return request({
    url: '/global/timelyEvents',
    method: 'get'
  })
}

/**
 * @description 获取所有资源
 */
export function ALL_RESOURCES() {
  // 接口请求
  return request({
    url: '/global/resources',
    method: 'get'
  })
}

/**
 * @description 获取所有关系
 */
export function ALL_RELATIONS() {
  // 接口请求
  return request({
    url: '/global/relations',
    method: 'get'
  })
}


/**
 * @description 获取实例
 */
export function GET_ENTITY({uri, params = {}, headers={}}) {
  // 接口请求
  return request({
    url: uri,
    params,
    method: 'get',
	headers
  })
}

/**
 * @description 按照ID获取实例
 */
export function GET_ENTITY_BY_ID({
  domain,
  id,
  params = {},
}) {
  return request({
    url: `/${domain}/${id}`,
    params,
    method: 'get',
  })
}

/**
 * @description 保存实例
 */
export function POST_ENTITY({
  uri,
  data,
  headers = {},
  params = {},
}) {
  // 接口请求
  return request({
    url: uri,
    method: 'post',
    data,
	headers,
	params,
  })
}

/**
 * @description 保存实例
 */
export function PATCH_ENTITY({
  uri,
  data,
  headers = {}
}) {
  // 接口请求
  return request({
    url: uri,
    method: 'patch',
    data,
	headers
  })
}

/**
 * @description 保存实例
 */
export function PATCH_ENTITY_BY_ID({
  domain,
  id,
  data,
}) {
  // 接口请求
  return request({
    url: `/${domain}/${id}`,
    method: 'patch',
    data
  })
}

/**
 * @description 保存实例
 */
export function PUT_ENTITY_BY_ID({
  domain,
  id,
  data,
}) {
  // 接口请求
  return request({
    url: `/${domain}/${id}`,
    method: 'put',
    data
  })
}

/**
 * @description 添加关联
 */
export function PUT_ENTITY_URIS({
  uri,
  uris = []
}) {
  // 接口请求
  return request({
    url: uri,
    method: 'put',
    headers: {
      'Content-Type': 'text/uri-list'
    },
    data: uris.join("\n")
  })
}
